import React, {useState, useEffect} from "react";
import regions from "../../../assets/static_json/regions.json";
import roleList from "../../../assets/static_json/roles.json";
import RestService from "../../../services/rest-service";
import restService from "../../../services/restService";

const formKeys = ["name", "country_id", "email", "msisdn", "address"]
const UpdateAgency = ({agency, onSubmit, initCallback}) => {
    const [errors, setErrors] = useState({});
    const [countries, setCountries] = useState([]);
    const [form, setForm] = useState({...agency, calling_code : ''});

    const validateForm = () => {
        let errorList = {}
        formKeys.forEach(key => {
            // TODO validate phone numbers
            if (!form[key]){
                errorList[key] = "This field is required."
            } else {
                if (key === "email"){
                    const regex = /\S+@\S+\.\S+/;
                    if(!regex.test(form[key])){
                        errorList[key] = "Enter a valid email."
                    }
                }
            }
        })
        setErrors(errorList);
        return Object.keys(errorList).length === 0;
    }

    const onFormChange = ({target}) => {
        let details = {...form}
        details[target.name] = target.value;
        let errorList = errors;
        delete errorList[target.name];
        setErrors(errorList)

        if (target.name === "country_id"){
            const country = countries.filter(c => c.id == target.value)[0];
            details.calling_code = country?.calling_code;
        }
        setForm(details);

    }

    const handleSubmit = () => {
        //Api request to save agency
        if (validateForm()){
            let data = {...form};
            data.msisdn = form.calling_code + form.msisdn

            restService.AgencyApi.updateAgency(data).then((response) => {
                onSubmit()
            })

        }
    }
    useEffect(() => {
        RestService.getCountries().then(({data}) => {
            setCountries(data?.data)
            setForm({...form, calling_code: agency.country.calling_code, country_id: data?.data.filter(country => {return country.name === agency.country?.name})[0].id})
        })
    }, []);

    useEffect(() => {
        initCallback(handleSubmit)
    }, [form])


    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            <div className="text-center mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Update Agency</h2>
                <p className="text-gray-600">Modify the agency information below</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Agency Name <span className="text-red-500">*</span>
                    </label>
                    <input 
                        type="text" 
                        value={form.name} 
                        onChange={onFormChange} 
                        name="name" 
                        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                            errors.name ? 'border-red-300 bg-red-50' : 'border-gray-300'
                        }`}
                        placeholder="WestView Finances"
                    />
                    {errors.name && (
                        <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.name}
                        </p>
                    )}
                </div>

                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Address <span className="text-red-500">*</span>
                    </label>
                    <input 
                        type="text" 
                        value={form.address} 
                        onChange={onFormChange} 
                        name="address" 
                        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                            errors.address ? 'border-red-300 bg-red-50' : 'border-gray-300'
                        }`}
                        placeholder="Enter agency address"
                    />
                    {errors.address && (
                        <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.address}
                        </p>
                    )}
                </div>

                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Email Address <span className="text-red-500">*</span>
                    </label>
                    <input 
                        type="email" 
                        value={form.email} 
                        onChange={onFormChange} 
                        name="email" 
                        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                            errors.email ? 'border-red-300 bg-red-50' : 'border-gray-300'
                        }`}
                        placeholder="agency@example.com"
                    />
                    {errors.email && (
                        <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.email}
                        </p>
                    )}
                </div>

                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Phone Number <span className="text-red-500">*</span>
                    </label>
                    <div className="flex space-x-3 w-full">
                        <div className="w-16 flex-shrink-0">
                            <input 
                                disabled={true} 
                                type="text" 
                                value={form.calling_code}  
                                className="w-full px-2 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-700 cursor-not-allowed text-center font-medium text-sm"
                                placeholder="+44"
                            />
                        </div>
                        <div className="flex-1 min-w-0">
                            <input 
                                type="tel" 
                                value={form.msisdn} 
                                onChange={onFormChange} 
                                name="msisdn" 
                                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                                    errors.msisdn ? 'border-red-300 bg-red-50' : 'border-gray-300'
                                }`}
                                placeholder="548410151"
                            />
                        </div>
                    </div>
                    {errors.msisdn && (
                        <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.msisdn}
                        </p>
                    )}
                </div>

                <div className="space-y-2 md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Country <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                        <select 
                            value={form.country_id} 
                            onChange={onFormChange} 
                            name="country_id" 
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 appearance-none bg-white"
                        >
                            <option value="" disabled>Select a country</option>
                            {countries.map(country => (
                                <option key={country.id} value={country.id}>
                                    {country.name}
                                </option>
                            ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            {/* Information Panel */}
            <div className="mt-8 bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center space-x-2">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h4 className="text-sm font-medium text-green-900">Update Information</h4>
                </div>
                <p className="text-sm text-green-700 mt-1">
                    Make sure all information is accurate before saving. Changes will be applied immediately and may affect ongoing operations.
                </p>
            </div>
        </div>
    )
}
export default UpdateAgency;
